import { render, staticRenderFns } from "./selectFrame.vue?vue&type=template&id=67756dd7&"
import script from "./selectFrame.vue?vue&type=script&lang=ts&"
export * from "./selectFrame.vue?vue&type=script&lang=ts&"
import style0 from "./selectFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports